import React, { Component } from 'react';
import CandidatesDashboardView from './CandidatesDashboardView'
import { url } from '../../../Server/url/GlobalUrl'

class CandidatesDashboardComponent extends Component {
     state={
                candidates_detail: [],
                modal_show: false,
                authResponse: '',
            }
 componentDidMount() {
    fetch((url + "/api/v1/user/submit-details/?is_candidate=true"), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                   'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)
		            this.setState({
		                candidates_detail : result
		            })
		        })

		 }
     hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }

    handledelete = (id) => {
        console.log('hello all deleted',id)
         fetch((url + "/api/v1/user/submit-details/" + id + '/'), {
                method: 'DELETE',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
                .then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200 || response['status'] === 204) {
                this.showCustomModal()
				this.setState({authResponse:'Deleted Successfully'})
                fetch((url + "/api/v1/user/submit-details/"), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)
		            this.setState({
		                candidates_detail : result
		            })
		        })
            } else if (response['status'] === 400) {
                this.showCustomModal()
				this.setState({authResponse:'Something went wrong please try again'})
            }
        })
    }
    handlepreview = (id) => {
        console.log('id', id)
        localStorage.removeItem('from_applicant')
        // localStorage.setItem('cv-id',id)
        // localStorage.setItem('actual-id',id)
        localStorage.setItem('cv-id-preview',id)
       window.location.replace('/registration/cv-summary')
    }


 render() {
        return (
            <CandidatesDashboardView
                  candidates_detail = {this.state.candidates_detail}
                  handledelete = {this.handledelete}
                  authResponse={this.state.authResponse}
                  modal_show={this.state.modal_show}
                  hideCustomModal={this.hideCustomModal}
                  handlepreview={this.handlepreview}
            />
        )
    }

}

export default CandidatesDashboardComponent;